import { useEffect } from "react";
import { pingUser } from "../Components/Api/headless";
import { useAppSelector } from "../redux-stores/hooks/hooks";
import { selectConversationUser } from "../redux-stores/reducers/ConversationState";

export function useUserPing() {
  const userid = useAppSelector(selectConversationUser);
  useEffect(() => {
    if (userid) {
      console.debug("Start ping", userid);
      const interval = setInterval(() => {
        pingUser(userid);
        console.debug("Pinged", userid);
      }, 5_000);
      return () => {
        clearInterval(interval);
      };
    }
  }, [userid]);
}
